import * as React from 'react'; // https://github.com/parcel-bundler/parcel/issues/1199
import { FormattedHTMLMessage } from 'react-intl';
import { setRef, InputSelectComponentProps, FormSelectChoice } from '@sheerid/jslib';

const FirstResponderStatusComponent = ({
    onChange,
    value,
    isErrored,
    options,
}: InputSelectComponentProps) => {

    return (
        <div className="sid-field sid-first-responder-status">
            <div className="sid-l-space-top-md" />
            <label htmlFor="sid-first-responder-status">
                <div className="sid-field__label sid-field__label--required sid-first-responder-status__label sid-l-space-btm-sm">
                    <FormattedHTMLMessage
                        id="status"
                        defaultMessage="Status"
                    />
                </div>
            </label>
            <select
                id={'sid-first-responder-status'}
                className={`sid-l-full-width sid-text-input sid-text-input--required ${isErrored ? 'sid-text-input--error' : ''}`}
                onChange={e => onChange(e.target.value)}
                value={value.value}
                ref={input => setRef('status', input)}
            >
                {/* option tags have issues with FormattedHTMLMessage's. This is a way around that. */}
                <FormattedHTMLMessage
                    id="status.placeholder"
                    defaultMessage="-- Select One --"
                >
                    {(message) => <option>{message}</option>}
                </FormattedHTMLMessage>

                {
                    options.map((segment: FormSelectChoice<string | number, string>, key: number) =>{
                        return <option value={segment.value} key={key}>{segment.label}</option>
                    })
                }
            </select>
            {
                isErrored ? (
                    <div className="sid-field-error">
                        <FormattedHTMLMessage
                            id="errorId.invalidStatus"
                            defaultMessage="Invalid first responder status"
                        />
                    </div>
                ) : null
            }
        </div>
    );
};

export { FirstResponderStatusComponent };
